import React from 'react'
import Svg from './Svg'
export const SvgMeasureLine = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M17.455 0L0 17.455 6.545 24 24 6.545 17.455 0zm3.271 7.637l-1.092-1.092-1.092 1.092 1.092 1.092-1.092 1.092-2.179-2.184-1.092 1.092 2.182 2.181-1.09 1.09-1.092-1.092L14.18 12l1.092 1.092-1.092 1.092L12 12l-1.092 1.092 2.182 2.182-1.09 1.09-1.092-1.09-1.092 1.092 1.092 1.092-1.092 1.092-2.18-2.187-1.091 1.092 2.181 2.182-2.181 2.181-4.363-4.363L17.455 2.182l4.363 4.363-1.092 1.092z" />
  </Svg>
))
SvgMeasureLine.isIcon = true
export default SvgMeasureLine
